export default{
    login:{
        method:'post',
        url:'user/login'
    },
    cadastro:{
        method:'post',
        url:'usuario/empresa/cadastro'
    },
    dadospessoais:{
        method:'post',
        url:'user/update'
    },
    cadastrosenha:{
        method:'post',
        url:'recupera/senha'
    },
    updatesenha:{
        method:'post',
        url:'senha/update'
    },
    recupera:{
        method:'post',
        url:'login/esquecir/senha'
    },
    session:{
        method:'get',
        url:'user'
    },
    logout:{
        method:'get',
        url:'user/logout'
    },
    contrato:{
        method:'post',
        url:'contrata/mobe'
    },
    editar:{
        method:'get',
        url:'user/editar'
    },
    verificacodigo:{
        method:'get',
        url:'codigo/veificar{/codigo}'
    },
    listanotificacao:{
        method:'get',
        url:'notificacao/lista'
    },
    editanotificacao:{
        method:'get',
        url:'notificacao/show{/id}'
    },
    deletenotificacao:{
        method:'delete',
        url:'notificacao/deletar{/id}'
    },
}